export default __webpack_public_path__ + "static/media/79@2x-8.4f616be2.png";